import BaseObject from '../../../../base/base_object';
import Model from './fabric_hybrid_model';
import {FABRIC} from './fabric_hybrid_consts';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import Device from "../../../../utils/device/device";
import _ from "../../../../utils/underscore";


/**
 *
 *
 */
class Fabric extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Fabric';
    _model = null;
    _HybridService = null;
    _bEnable = false;

    init(params) {

        super.init();

        this._model = Model.create(params);

        if(_.isNullOrUndefined(params)){
            return;
        }
        if (Device.hybrid.inCasino) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if(!_.isNullOrUndefined(params) && params.enable){
            this._subscribe();
        }
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        return this;
    }

    _subscribe() {
        this._bEnable = true;
        Event.on(SYSTEM_EVENTS.FABRIC_ADD_EVENT, this._addEvent, this);
    }

    /**
     * add Event to fabric
     * @param ev the event to write
     * Example of adding 3 keys with single event:
        this._HybridService.createFabricEv('evName500');
        let ev = this._HybridService.addFabricKeyVal('key111', 'val111');
        ev = this._HybridService.addFabricKeyVal('key222', 'val222');
        ev = this._HybridService.addFabricKeyVal('key333', 'val223333');
        Event.fire(SYSTEM_EVENTS.FABRIC_ADD_EVENT, ev);
     */
    _addEvent(ev) {

        if (this._IsValid(ev) && null !== this._HybridService) {
            this._HybridService.addFabricEvent(ev);
        }
    }

    _IsValid(ev){

        if (!this._bEnable || _.isNullOrUndefined(ev) || _.isNullOrUndefined(ev.evName)) {
            return false;
        }

        for (let key in ev.evkeys)
        {
            if(!key.startsWith(FABRIC.START_WITH))
            {
                return false;
            }
        }

        return true;
    }

    createEvName(name){
        this._model.createEvName(name);
    }

    addEvKeyVal(key, val){
        return this._model.addEvKeyVal(key, val);
    }

    getEv(){
        return this._model.getEv();
    }
}

export default Fabric;
